import ApplicationModel, { attr } from '../ApplicationModel';
import { type PriorityListUnprioritizedRecordAttributes } from './generated/PriorityListUnprioritizedRecordAttributes';
import { model } from '../modelBuilder';

interface PriorityListUnprioritizedRecord
  extends PriorityListUnprioritizedRecordAttributes {}

@model
class PriorityListUnprioritizedRecord extends ApplicationModel {
  // Start auto-generated
  static typename: 'PriorityListUnprioritizedRecord' =
    'PriorityListUnprioritizedRecord';
  get typename(): 'PriorityListUnprioritizedRecord' {
    return 'PriorityListUnprioritizedRecord';
  }

  static fields = {
    prioritizable: attr({ readable: true }),
    record: attr.belongsTo({
      readable: true,
      typename: ['Epic', 'Feature', 'Idea', 'Initiative'],
    }),
  };
  // End auto-generated
}

export default PriorityListUnprioritizedRecord;
